import { FaBookOpen, FaChartLine, FaClipboardList, FaUsers } from "react-icons/fa";
import { isParentRole } from "./lmsRole";

export const getLmsNavigationItems = (role) => {
  const isParent = isParentRole(role);
  return [
    { label: "Dashboard", path: "/dashboard", icon: FaChartLine },
    { label: isParent ? "My Kids" : "Students", path: "/dashboard/students", icon: FaUsers },
    { label: "Reading Library", path: "/dashboard/library", icon: FaBookOpen },
    { label: "Assignments", path: "/dashboard/assignments", icon: FaClipboardList },
    { label: "Reports", path: "/dashboard/reports", icon: FaChartLine },
  ];
};

export const getLmsDashboardCopy = (role) => {
  const isParent = isParentRole(role);

  return {
    audienceLabel: isParent ? "Parent workspace" : "Teacher workspace",
    greeting: isParent ? "Build a reading rhythm at home" : "Guide every reader forward",
    intro: isParent
      ? "Create your kids' reading profiles, choose meaningful content, and follow progress as confidence grows."
      : "Create student profiles, shape reading content, assign challenges, and review growth from one welcoming space.",
    studentLabel: isParent ? "kids" : "students",
    emptyTitle: isParent
      ? "Your family's reading journey starts here"
      : "Your classroom reading journey starts here",
    emptyBody: isParent
      ? "Create your first kid profile and assign a challenge that fits their reading level."
      : "Create your first student and assign their first challenge.",
  };
};

export const getJourneySteps = (role) => {
  const isParent = isParentRole(role);

  return [
    isParent ? "Create Kids" : "Create Students",
    "Create Reading Content",
    "Assign Reading Challenges",
    isParent ? "Kids Complete Reading" : "Students Complete Reading",
    "Review Growth & Progress",
  ];
};

export const progressCards = [
  { label: "Active readers", value: "0", hint: "Add profiles to begin tracking growth." },
  { label: "Challenges assigned", value: "0", hint: "Assignments will appear once content is ready." },
  { label: "Growth signals", value: "Ready", hint: "Reports will highlight reading progress over time." },
];
